export default {
  text: '#353535',
  primary: 'black',
  secondary: '#6c6c6c',
  background: '#fdfdfd',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#202020',
}
